import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m6.719 13.789-5.5-5.257a.755.755 0 0 1 0-1.064l5.5-5.257c.312-.281.781-.281 1.062 0a.747.747 0 0 1 0 1.064L3.625 7.25H14.25c.406 0 .75.344.75.751a.761.761 0 0 1-.75.751H3.625l4.156 3.974a.747.747 0 0 1 0 1.064c-.281.281-.75.281-1.062 0Z"
    }, null, -1)
  ])))
}
export default { render: render }